import React, { createContext, useContext, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import Loader from "../Components/Common/Loader/Loader";

type LoadingBackdropContextType = {
    show: (msg?: string) => void;
    hide: () => void;
};

const LoadingBackdropContext = createContext<LoadingBackdropContextType>({
    show: () => {},
    hide: () => {},
});

export const useLoadingBackdrop = () => useContext(LoadingBackdropContext);

export const LoadingBackdropProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState<string | undefined>();

    const show = (msg?: string) => {
        setMessage(msg);
        setOpen(true);
    };
    const hide = () => setOpen(false);

    return (
        <LoadingBackdropContext.Provider value={{ show, hide }}>
            {children}
            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 999,
                    backgroundColor: "rgba(0,0,0,0.7)", // lighter blackout
                }}
                open={open}
                transitionDuration={400}
            >
                <Fade in={open} timeout={400}>
                    <Box display="flex" flexDirection="column" alignItems="center">
                        <Loader />
                        {message && (
                            <Typography
                                variant="h6"
                                sx={{
                                    mt: 2,
                                    letterSpacing: 1,
                                    fontWeight: 500,
                                    animation: open
                                        ? "fadeInText 0.7s"
                                        : "none",
                                    "@keyframes fadeInText": {
                                        "0%": { opacity: 0, transform: "translateY(10px)" },
                                        "100%": { opacity: 1, transform: "translateY(0)" },
                                    },
                                }}
                            >
                                {message}
                            </Typography>
                        )}
                    </Box>
                </Fade>
            </Backdrop>
        </LoadingBackdropContext.Provider>
    );
};